<template>
  <div class="page-wrapper">
    <!-- PC 端 -->
    <div class="pc-version">
      <div class="coupon-table-container" v-loading="loading">
        <div class="search-bar">
          <el-input
            v-model="searchParams.name"
            placeholder="请输入优惠券名称"
            clearable
            style="width: 220px"
          ></el-input>

          <el-select
            v-model="searchParams.type"
            placeholder="优惠券类型"
            clearable
            style="width: 200px"
          >
            <el-option
              v-for="item in couponTypes"
              :key="item.type"
              :label="item.desc"
              :value="item.type"
            ></el-option>
          </el-select>

          <el-select
            v-model="searchParams.status"
            placeholder="状态"
            clearable
            style="width: 150px"
          >
            <el-option label="上架" :value="1"></el-option>
            <el-option label="下架" :value="0"></el-option>
          </el-select>

          <el-button type="primary" icon="el-icon-search" @click="getCouponList"
            >搜索</el-button
          >
          <el-button icon="el-icon-refresh" @click="resetSearch"
            >重置</el-button
          >
          <el-button type="success" icon="el-icon-plus" @click="handleAdd"
            >新增</el-button
          >
        </div>

        <el-table
          :data="tableData"
          border
          stripe
          style="width: 100%; margin-top: 20px"
          @row-click="handleRowClick"
        >
          <el-table-column label="ID" prop="id" width="80" align="center" />
          <el-table-column label="优惠券名称" prop="name" min-width="180" />
          <el-table-column
            label="优惠券类型"
            prop="type_desc"
            width="120"
            align="center"
          />
          <el-table-column
            label="抵扣金额"
            prop="amount"
            width="100"
            align="center"
          />
          <el-table-column
            label="最低使用金额"
            prop="min_amount"
            width="120"
            align="center"
          />
          <el-table-column
            label="发放数量"
            prop="num"
            width="100"
            align="center"
          />
          <el-table-column
            label="有效天数"
            prop="expired_day"
            width="100"
            align="center"
          />
          <el-table-column label="使用范围" width="120" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.format == 0">全部盲盒</span>
              <span v-else>盲盒{{ scope.row.format }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" width="180" align="center">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.status"
                :active-value="1"
                :inactive-value="0"
                active-text="上架"
                inactive-text="下架"
                @click.native.stop
                @change="handleStatusChange(scope.row)"
              />
            </template>
          </el-table-column>
          <el-table-column label="创建时间" prop="created_at" width="180" />
          <el-table-column label="操作" width="180" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-edit"
                @click.native.stop="handleEdit(scope.row)"
                >编辑</el-button
              >
              <el-button
                type="text"
                icon="el-icon-delete"
                style="color: #f56c6c"
                @click.native.stop="handleDelete(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchParams.page"
          :page-size="searchParams.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageInfo.total"
          style="margin-top: 20px; text-align: right"
        ></el-pagination>

        <el-dialog
          :title="isEdit ? '编辑优惠券' : '新增优惠券'"
          :visible.sync="dialogVisible"
          width="600px"
          @close="resetForm"
          append-to-body
        >
          <el-form
            :model="form"
            :rules="rules"
            ref="formRef"
            label-width="120px"
          >
            <el-form-item label="优惠券名称" prop="name">
              <el-input v-model="form.name"></el-input>
            </el-form-item>

            <!-- 优惠券类型：取自接口 type 数组 -->
            <el-form-item label="优惠券类型" prop="type">
              <el-select v-model="form.type" placeholder="请选择类型">
                <el-option
                  v-for="item in couponTypes"
                  :key="item.type"
                  :label="item.desc"
                  :value="item.type"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="抵扣金额" prop="amount">
              <el-input v-model.number="form.amount" type="number"></el-input>
            </el-form-item>
            <el-form-item label="最低使用金额" prop="min_amount">
              <el-input
                v-model.number="form.min_amount"
                type="number"
              ></el-input>
            </el-form-item>
            <el-form-item label="发放数量" prop="num">
              <el-input v-model.number="form.num" type="number"></el-input>
            </el-form-item>
            <el-form-item label="有效天数" prop="expired_day">
              <el-input
                v-model.number="form.expired_day"
                type="number"
              ></el-input>
            </el-form-item>
            <el-form-item label="使用范围" prop="format">
              <el-input
                v-model.number="form.format"
                placeholder="0=全部通用"
              ></el-input>
            </el-form-item>
            <el-form-item label="状态" prop="status">
              <el-switch
                v-model="form.status"
                :active-value="1"
                :inactive-value="0"
              ></el-switch>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="submitForm">确认提交</el-button>
          </div>
        </el-dialog>

        <!-- PC 完整详情 -->
        <el-dialog
          title="优惠券详情"
          :visible.sync="detailVisible"
          width="700px"
          append-to-body
        >
          <el-form :model="detailForm" label-width="120px" size="small">
            <el-form-item label="ID"
              ><span>{{ detailForm.id }}</span></el-form-item
            >
            <el-form-item label="优惠券名称"
              ><span>{{ detailForm.name }}</span></el-form-item
            >
            <el-form-item label="优惠券类型"
              ><span>{{ detailForm.type_desc }}</span></el-form-item
            >
            <el-form-item label="抵扣金额"
              ><span>¥ {{ detailForm.amount }}</span></el-form-item
            >
            <el-form-item label="最低使用金额"
              ><span>¥ {{ detailForm.min_amount }}</span></el-form-item
            >
            <el-form-item label="发放数量"
              ><span>{{ detailForm.num }} 张</span></el-form-item
            >
            <el-form-item label="有效天数"
              ><span>{{ detailForm.expired_day }} 天</span></el-form-item
            >
            <el-form-item label="使用范围">
              <span>{{
                detailForm.format == 0 ? "全部盲盒" : "盲盒" + detailForm.format
              }}</span>
            </el-form-item>
            <el-form-item label="状态">
              <span
                :style="detailForm.status == 1 ? 'color:green' : 'color:red'"
              >
                {{ detailForm.status == 1 ? "上架中" : "已下架" }}
              </span>
            </el-form-item>
            <el-form-item label="创建时间"
              ><span>{{ detailForm.created_at }}</span></el-form-item
            >
            <el-form-item label="更新时间"
              ><span>{{ detailForm.updated_at }}</span></el-form-item
            >
          </el-form>
          <div slot="footer">
            <el-button @click="detailVisible = false">关闭</el-button>
          </div>
        </el-dialog>
      </div>
    </div>

    <!-- 移动端 -->
    <div class="mobile-version">
      <div class="mobile-coupon-container" v-loading="loading">
        <div class="mobile-search-group">
          <el-input
            v-model="searchParams.name"
            placeholder="优惠券名称"
            clearable
            size="medium"
            prefix-icon="el-icon-search"
          />
          <div style="display: flex; gap: 8px; margin-top: 8px">
            <el-select
              v-model="searchParams.type"
              placeholder="类型"
              clearable
              size="medium"
              style="flex: 1"
            >
              <el-option
                v-for="item in couponTypes"
                :key="item.type"
                :label="item.desc"
                :value="item.type"
              />
            </el-select>
            <el-select
              v-model="searchParams.status"
              placeholder="状态"
              clearable
              size="medium"
              style="flex: 1"
            >
              <el-option label="上架" :value="1"></el-option>
              <el-option label="下架" :value="0"></el-option>
            </el-select>
          </div>
          <div style="display: flex; gap: 8px; margin-top: 8px">
            <el-button
              type="primary"
              plain
              round
              @click="getCouponList"
              style="flex: 1"
              >搜索</el-button
            >
            <el-button plain round @click="resetSearch" style="flex: 1"
              >重置</el-button
            >
            <el-button
              type="success"
              plain
              round
              @click="openMobileAdd"
              style="flex: 1"
              >添加</el-button
            >
          </div>
        </div>

        <div class="mobile-card-list">
          <div
            class="mobile-card"
            v-for="item in tableData"
            :key="item.id"
            @click="openMobileDetail(item)"
          >
            <div class="card-header">
              <div class="info">
                <div class="title">{{ item.name }}</div>
                <div class="meta">ID:{{ item.id }} | {{ item.type_desc }}</div>
              </div>
              <div class="status" :class="item.status == 1 ? 'on' : 'off'">
                {{ item.status == 1 ? "上架" : "下架" }}
              </div>
            </div>
            <div class="card-body">
              <div>抵扣：¥{{ item.amount }} | 最低：¥{{ item.min_amount }}</div>
              <div>数量：{{ item.num }} | 有效期：{{ item.expired_day }}天</div>
            </div>
            <div class="card-footer">
              <el-button
                size="mini"
                type="primary"
                round
                @click.stop="openMobileEdit(item)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                type="danger"
                round
                @click.stop="handleMobileDelete(item)"
                >删除</el-button
              >
              <el-switch
                v-model="item.status"
                :active-value="1"
                :inactive-value="0"
                size="mini"
                @click.native.stop
                @change="handleStatusChange(item)"
              />
            </div>
          </div>
        </div>

        <!-- 移动端详情 -->
        <el-dialog
          title="优惠券详情"
          :visible.sync="mobileDetailVisible"
          width="90%"
          append-to-body
        >
          <el-form :model="mobileDetailRow" label-width="100px" size="small">
            <el-form-item label="ID"
              ><span>{{ mobileDetailRow.id }}</span></el-form-item
            >
            <el-form-item label="名称"
              ><span>{{ mobileDetailRow.name }}</span></el-form-item
            >
            <el-form-item label="类型"
              ><span>{{ mobileDetailRow.type_desc }}</span></el-form-item
            >
            <el-form-item label="抵扣"
              ><span>¥ {{ mobileDetailRow.amount }}</span></el-form-item
            >
            <el-form-item label="最低消费"
              ><span>¥ {{ mobileDetailRow.min_amount }}</span></el-form-item
            >
            <el-form-item label="数量"
              ><span>{{ mobileDetailRow.num }} 张</span></el-form-item
            >
            <el-form-item label="有效期"
              ><span>{{ mobileDetailRow.expired_day }} 天</span></el-form-item
            >
            <el-form-item label="使用范围">
              <span>{{
                mobileDetailRow.format == 0
                  ? "全部盲盒"
                  : "盲盒" + mobileDetailRow.format
              }}</span>
            </el-form-item>
            <el-form-item label="状态">
              <span
                :style="
                  mobileDetailRow.status == 1 ? 'color:green' : 'color:red'
                "
              >
                {{ mobileDetailRow.status == 1 ? "上架中" : "已下架" }}
              </span>
            </el-form-item>
            <el-form-item label="创建时间"
              ><span>{{ mobileDetailRow.created_at }}</span></el-form-item
            >
          </el-form>
          <div slot="footer">
            <el-button @click="mobileDetailVisible = false">关闭</el-button>
          </div>
        </el-dialog>

        <!-- 移动端添加 -->
        <el-dialog
          title="添加优惠券"
          :visible.sync="mobileAddVisible"
          width="95%"
          top="10vh"
          append-to-body
        >
          <el-form
            :model="mobileAddForm"
            :rules="rules"
            ref="mobileAddRef"
            label-width="100px"
            size="small"
          >
            <el-form-item label="优惠券名称" prop="name">
              <el-input v-model="mobileAddForm.name" size="medium" />
            </el-form-item>
            <el-form-item label="优惠券类型" prop="type">
              <el-select
                v-model="mobileAddForm.type"
                placeholder="请选择"
                size="medium"
              >
                <el-option
                  v-for="item in couponTypes"
                  :key="item.type"
                  :label="item.desc"
                  :value="item.type"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="抵扣金额" prop="amount">
              <el-input
                v-model.number="mobileAddForm.amount"
                type="number"
                size="medium"
              />
            </el-form-item>
            <el-form-item label="最低使用" prop="min_amount">
              <el-input
                v-model.number="mobileAddForm.min_amount"
                type="number"
                size="medium"
              />
            </el-form-item>
            <el-form-item label="发放数量" prop="num">
              <el-input
                v-model.number="mobileAddForm.num"
                type="number"
                size="medium"
              />
            </el-form-item>
            <el-form-item label="有效天数" prop="expired_day">
              <el-input
                v-model.number="mobileAddForm.expired_day"
                type="number"
                size="medium"
              />
            </el-form-item>
            <el-form-item label="使用范围" prop="format">
              <el-input
                v-model.number="mobileAddForm.format"
                placeholder="0=全部"
                size="medium"
              />
            </el-form-item>
            
          </el-form>
          <div
            slot="footer"
            style="display: flex; justify-content: flex-end; gap: 10px"
          >
            <el-button size="medium" @click="mobileAddVisible = false"
              >取消</el-button
            >
            <el-button type="primary" size="medium" @click="submitMobileAdd"
              >保存</el-button
            >
          </div>
        </el-dialog>

        <!-- 移动端编辑 -->
        <el-dialog
          title="编辑优惠券"
          :visible.sync="mobileEditVisible"
          width="95%"
          top="10vh"
          append-to-body
        >
          <el-form
            :model="mobileEditForm"
            :rules="rules"
            ref="mobileEditRef"
            label-width="100px"
            size="small"
          >
            <el-form-item label="优惠券名称" prop="name">
              <el-input v-model="mobileEditForm.name" size="medium" />
            </el-form-item>
            <el-form-item label="优惠券类型" prop="type">
              <el-select
                v-model="mobileEditForm.type"
                placeholder="请选择"
                size="medium"
              >
                <el-option
                  v-for="item in couponTypes"
                  :key="item.type"
                  :label="item.desc"
                  :value="item.type"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="抵扣金额" prop="amount">
              <el-input
                v-model.number="mobileEditForm.amount"
                type="number"
                size="medium"
              />
            </el-form-item>
            <el-form-item label="最低使用" prop="min_amount">
              <el-input
                v-model.number="mobileEditForm.min_amount"
                type="number"
                size="medium"
              />
            </el-form-item>
            <el-form-item label="发放数量" prop="num">
              <el-input
                v-model.number="mobileEditForm.num"
                type="number"
                size="medium"
              />
            </el-form-item>
            <el-form-item label="有效天数" prop="expired_day">
              <el-input
                v-model.number="mobileEditForm.expired_day"
                type="number"
                size="medium"
              />
            </el-form-item>
            <el-form-item label="使用范围" prop="format">
              <el-input
                v-model.number="mobileEditForm.format"
                placeholder="0=全部"
                size="medium"
              />
            </el-form-item>
            <!-- <el-form-item label="状态" prop="status">
              <el-switch
                v-model="mobileEditForm.status"
                :active-value="1"
                :inactive-value="0"
              ></el-switch>
            </el-form-item> -->
          </el-form>
          <div
            slot="footer"
            style="display: flex; justify-content: flex-end; gap: 10px"
          >
            <el-button size="medium" @click="mobileEditVisible = false"
              >取消</el-button
            >
            <el-button type="primary" size="medium" @click="submitMobileEdit"
              >保存</el-button
            >
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api/api.js";
export default {
  name: "CouponTable",
  data() {
    return {
      loading: false,
      tableData: [],
      pageInfo: { total: 0 },
      couponTypes: [], // 接口返回的优惠券类型数组
      searchParams: { page: 1, page_size: 10, name: "", type: "", status: "" },
      dialogVisible: false,
      isEdit: false,
      form: {
        id: "",
        name: "",
        type: "",
        amount: "",
        min_amount: "",
        num: "",
        expired_day: "",
        format: "",
        status: 1,
      },
      rules: {
        name: [
          { required: true, message: "请输入优惠券名称", trigger: "blur" },
        ],
        type: [
          { required: true, message: "请选择优惠券类型", trigger: "change" },
        ],
        amount: [
          { required: true, message: "请输入抵扣金额", trigger: "blur" },
        ],
        min_amount: [
          { required: true, message: "请输入最低使用金额", trigger: "blur" },
        ],
        num: [{ required: true, message: "请输入发放数量", trigger: "blur" }],
        expired_day: [
          { required: true, message: "请输入有效天数", trigger: "blur" },
        ],
        format: [
          { required: true, message: "请输入使用范围", trigger: "blur" },
        ],
      },
      detailVisible: false,
      detailForm: {},

      // 移动端
      mobileDetailVisible: false,
      mobileDetailRow: {},
      mobileAddVisible: false,
      mobileAddForm: { status: 1 },
      mobileEditVisible: false,
      mobileEditForm: {},
    };
  },
  created() {
    this.getCouponList();
  },
  methods: {
    // 核心：获取列表时，同时加载优惠券类型
    getCouponList() {
      this.loading = true;
      api.coupon
        .index({ params: this.searchParams })
        .then((res) => {
          if (res.data.code == 1000) {
            this.tableData = res.data.data.data;
            this.pageInfo.total = res.data.data.total;
            this.couponTypes = res.data.data.type || []; // 关键：赋值类型数组
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 移动端添加
    openMobileAdd() {
      this.mobileAddForm = {
        name: "",
        type: "",
        amount: "",
        min_amount: "",
        num: "",
        expired_day: "",
        format: "",
        status: 1,
      };
      this.mobileAddVisible = true;
    },
    async submitMobileAdd() {
      this.$refs.mobileAddRef.validate(async (valid) => {
        if (!valid) return;
        this.loading = true;
        try {
          let res = await api.coupon.add(this.mobileAddForm);
          if (res.data.code == 1000) {
            this.mobileAddVisible = false;
            this.getCouponList();
          }
        } catch (e) {
        } finally {
          this.loading = false;
        }
      });
    },

    // 移动端编辑
    openMobileEdit(row) {
      this.mobileEditForm = JSON.parse(JSON.stringify(row));
      this.mobileEditVisible = true;
    },
    async submitMobileEdit() {
      this.$refs.mobileEditRef.validate(async (valid) => {
        if (!valid) return;
        this.loading = true;
        try {
          let params = {
            ...this.mobileEditForm,
            coupon_id: this.mobileEditForm.id,
          };
          let res = await api.coupon.edit(params);
          if (res.data.code == 1000) {
            this.mobileEditVisible = false;
            this.getCouponList();
          }
        } catch (e) {
        } finally {
          this.loading = false;
        }
      });
    },

    // 移动端删除
    handleMobileDelete(row) {
      this.$confirm("确定删除？", "提示", { type: "warning" })
        .then(() => {
          this.loading = true;
          api.coupon.del({ coupon_id: row.id }).then((res) => {
            if (res.data.code == 1000) {
              this.getCouponList();
            }
            this.loading = false;
          });
        })
        .catch(() => {});
    },

    openMobileDetail(row) {
      this.mobileDetailRow = row;
      this.mobileDetailVisible = true;
    },

    // PC
    handleAdd() {
      this.isEdit = false;
      this.resetForm();
      this.dialogVisible = true;
    },
    handleEdit(row) {
      this.isEdit = true;
      this.form = { ...row };
      this.dialogVisible = true;
    },
    submitForm() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        let params = { ...this.form };
        if (this.isEdit) params.coupon_id = params.id;
        let req = this.isEdit
          ? api.coupon.edit(params)
          : api.coupon.add(params);
        req.then((res) => {
          if (res.data.code == 1000) {
            this.getCouponList();
            this.dialogVisible = false;
          }
          this.loading = false;
        });
      });
    },
    handleStatusChange(row) {
      api.coupon.status({ coupon_id: row.id, status: row.status });
    },
    handleDelete(row) {
      this.$confirm("确定删除？", "提示", { type: "warning" }).then(() => {
        api.coupon.del({ coupon_id: row.id }).then(() => this.getCouponList());
      });
    },
    resetForm() {
      this.form = {
        id: "",
        name: "",
        type: "",
        amount: "",
        min_amount: "",
        num: "",
        expired_day: "",
        format: "",
        status: 1,
      };
    },
    resetSearch() {
      this.searchParams = {
        page: 1,
        page_size: 10,
        name: "",
        type: "",
        status: "",
      };
      this.getCouponList();
    },
    handleSizeChange(val) {
      this.searchParams.page_size = val;
      this.getCouponList();
    },
    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.getCouponList();
    },
    handleRowClick(row) {
      this.detailForm = row;
      this.detailVisible = true;
    },
  },
};
</script>

<style scoped>
.coupon-table-container {
  padding: 20px;
}
.search-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 20px;
}
.dialog-footer {
  text-align: right;
}

/* 移动端 */
.mobile-coupon-container {
  padding: 12px;
}
.mobile-search-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}
.mobile-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.mobile-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.card-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
.title {
  font-size: 16px;
  font-weight: 500;
}
.meta {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}
.status {
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 4px;
  font-weight: bold;
}
.status.on {
  background: #e6f7ee;
  color: #00c48c;
}
.status.off {
  background: #fef0f0;
  color: #f56c6c;
}
.card-body {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 10px;
}
.card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/operate/coupon.vue